import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import AppreciationForm from '@/views/appreciation/form/index.vue'
import { getAppreciationInfo } from '@/services/appreciation'


export default {
  setup(__props) {

const router = useRouter()
const route = useRoute()

const firstLoading = ref(true)
const currentState = reactive({
  id: route.params.id || 0,
  title: route.params.id ? '编辑赏析资源' : '新建赏析资源'
})

const current = ref({})

const goBack = () => {
  router.go(-1)
}

onBeforeMount(async () => {
  if (currentState.id) {
    current.value = await getAppreciationInfo(currentState.id)
    firstLoading.value = false
  } else {
    firstLoading.value = false
  }
})

return (_ctx, _cache) => {
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: firstLoading.value }, {
    default: _withCtx(() => [
      _createVNode(_component_a_card, {
        title: _unref(currentState).title
      }, {
        extra: _withCtx(() => [
          _createElementVNode("a", { onClick: goBack }, "返回")
        ]),
        default: _withCtx(() => [
          (!firstLoading.value)
            ? (_openBlock(), _createBlock(AppreciationForm, {
                key: 0,
                current: current.value
              }, null, 8, ["current"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

}